<template>
  <section>
    <div class="content-wrapper main-container">
      <question v-if="display"></question>
      <spinner v-if="isSubmitSettingsLoading"></spinner>
      <div class="content-heading">
        Settings
        <small data-localize="dashboard.WELCOME"></small>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div id="panelChart9" class="panel panel-default">
            <div class="panel-heading">
              <div class="panel-title">Announcement</div>
              <div class="row">
                <div class="col">
                  <div>
                     <vue-editor :editorToolbar="customEditorToolbar" v-model="announcementHTML"></vue-editor>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="ml" v-html="announcementHTMLWithSafeLinks"></div>
                  <button type="submit" @click="handleSubmitSettings" class="btn btn-info btn-lg mt">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { VueEditor, Quill } from 'vue2-editor';
import Question from '@/components/modals/Question';
import {
    mapActions,
    mapState,
    mapMutations,
  } from 'vuex';
import spinner from '@/components/widgets/Spinner';
import {
    HIDE_QUESTION_MODAL,
    SHOW_QUESTION_MODAL,
    SET_ERRORS_MODAL_INFO,
    SHOW_ERRORS_MODAL,
  } from '@/store/mutation-types';
import { normalizeRichTextLinks } from '@/util';
import {
    Constants,
  } from '../data/static/constants';

// Quill keeps a link typed without a scheme (e.g. "www.calvertimpactcapital.org")
// as a relative href, which makes the browser resolve it against the portal
// origin instead of the external site. Default those links to https.
const Link = Quill.import('formats/link');
const quillSanitize = Link.sanitize;

Link.sanitize = function sanitize(url) {
  const value = (url || '').trim();
  const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(value);
  const isInternalReference = value.startsWith('#') || value.startsWith('/');

  if (!value || hasScheme || isInternalReference) {
    return quillSanitize.call(this, value);
  }
  return quillSanitize.call(this, `https://${value}`);
};

Quill.register(Link, true);

export default {
  name: 'adminSettings',
  components: {
    'vue-editor': VueEditor,
    question: Question,
    spinner,
  },
  beforeMount() {
    this.initializeAnnouncement();
  },
  data() {
    return {
      isSubmitSettingsLoading: false,
      announcementHTML: '',
      customEditorToolbar: Constants.richtext.customEditorToolbar,
    };
  },
  computed: {
    ...mapState('app', [
      'announcement',
    ]),
    announcementHTMLWithSafeLinks() {
      return normalizeRichTextLinks(this.announcementHTML);
    },
    ...mapState('question', [
      'display',
    ]),
  },
  methods: {
    async initializeAnnouncement() {
      const announcement = await this.getAnnouncement();

      this.announcementHTML = announcement.html || '';
    },
    handleSubmitSettings() {
      this.showQuestionModal({
        title: 'Update Announcement',
        question: 'Are you sure about these changes?',
        method: () => {
          this.methodToExecuteInUpdateAnnouncementQuestionModal();
        },
        yesButtonText: Constants.purchaseNote.modalYesButtonText,
        hideCancelButton: false,
      });
    },
    async methodToExecuteInUpdateAnnouncementQuestionModal() {
      this.hideQuestionModal();
      this.isSubmitSettingsLoading = true;
      try {
        await this.createAnnouncement({ html: this.announcementHTML });
        await this.initializeAnnouncement();
      } catch (err) {
        this.setErrorsModalInfo([err.message]);
        this.showErrorsModal();
      } finally {
        this.isSubmitSettingsLoading = false;
      }
    },
    ...mapActions('user', [
      'getAnnouncement',
      'createAnnouncement',
    ]),
    ...mapMutations('question', {
      hideQuestionModal: HIDE_QUESTION_MODAL,
      showQuestionModal: SHOW_QUESTION_MODAL,
    }),
    ...mapMutations('errors', {
      showErrorsModal: SHOW_ERRORS_MODAL,
      setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
    }),
  },
};
</script>

<style scoped>
.main-container {
  padding-top: 5;
}

.content-heading {
  font-weight: normal;
}

.panel-default {
  padding: 20px 30px;
}

.panel-heading {
  color: #444;
  background-color: #ffffff;
  border-color: #cfdbe2;
  border-bottom: 0;
  font-size: 14px;
  padding: 25px 5px;
}
</style>



// WEBPACK FOOTER //
// AdminSettings.vue?20031b14